module.exports = __webpack_public_path__ + "b8f7905b68f559c7267c96fe71bc2856.MP3";